import React, { useState, useEffect } from 'react';
import {
    Button, Card, CardBody, CardHeader, Col, FormGroup, Input, Label, Modal, ModalBody, ModalFooter, ModalHeader,
    Row,
} from 'reactstrap';
import AsyncSelect from 'react-select/lib/Async';
import 'react-select/dist/react-select.min.css';
import 'react-bootstrap-table/dist//react-bootstrap-table-all.min.css';
import 'spinkit/css/spinkit.css';
import { ToastContainer, toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import Widget from "../../components/Widget/Widget";
import gatewayService from "../../services/gatewayService";
import garageService from "../../services/garageService";
import getGaragesQuery from '../../queries/getGarages';
import datetimeFormatter from "../../utils/datetimeFormatter";
import Logs from "../../components/Logs";
import { history } from "../../App";
import assignSaltoGateway from "../../mutations/assignSaltoGateway";
import unassignSaltoGateway from "../../mutations/unassignSaltoGateway";
import dictionary from "../../utils/dictionary";
import { Link } from "react-router-dom";
import updateSaltoGateway from "../../mutations/updateSaltoGateway";
import deleteSaltoGateway from "../../mutations/deleteSaltoGateway";
import getSaltoGatewayById from "../../queries/getSaltoGatewayById";
import getSaltoGateways from "../../queries/getSaltoGateways";
import Select from "react-select";
import getTenantsQuery from "../../queries/getTenantsQuery";
import rebootNode from "../../mutations/rebootNode";


const SaltoGateway = (props) => {
    const [loading, setLoading] = useState(true);
    const [garageDataLoading, setGarageDataLoading] = useState(true);
    const [disabled, setDisabled] = useState(true);
    const [isUnassignNode, setUnassignNode] = useState(false);
    const [isUnassignSaltoGateway, setUnassignSaltoGateway] = useState(false);
    const [isAssignNode, setAssignNode] = useState(false);
    const [isAssignSaltoGateway, setAssignSaltoGateway] = useState(false);
    const [assignedValue, setAssignedValue] = useState('');
    const [tenants, setTenants] = useState([])
    const [productTypes, setProductType] = useState([{ value: "B2C", label: "B2C" }, { value: "B2B", label: "B2B" }, { value: "B2B_B2C", label: "Hybrid" },])
    const [gateway, setGateway] = useState(null);
    const [isDeleteGateway, setDeleteGateway] = useState(false);
    let typingTimer;
    const typingInterval = 600;

    useEffect(() => {
        fetchGateway();
    }, [props]);

    function fetchGateway() {
        const { match: { params } } = props;
        gatewayService.getService(getSaltoGatewayById(params))
            .then((gateway) => {
                console.log(gateway)
                setGateway(gateway.data.getSaltoGatewayById.gateway);
                setLoading(false);
                const gatewayName = gateway.data.getSaltoGatewayById.gateway.name;
                const gatewayGwid = gateway.data.getSaltoGatewayById.gateway.gwid;
                return document.title = `Salto Gateway | ${gatewayName || gatewayGwid || dictionary.NOT_AVAILABLE}`;
            })
            .catch((err) => {
                if (err.networkError && err.networkError.statusCode === 404) {
                    history.push('/404')
                }
            });
    }

    function handleProductType(product_type) {
        setGateway({
            ...gateway,
            product_type: !product_type ? null : product_type.value
        })
    }

    function handleTenant(tenant) {
        setGateway({
            ...gateway,
            tenant_id: !tenant ? null : tenant.value,
        });
    }

    function handleChange(event) {
        const target = event.target;
        let value = target.value;
        const name = target.name;
        let _gateway = { ...gateway };

        if (name === "type" && !value.length) {
            value = null;
        } else if (name === "lat" || name === "long") {
            _gateway.position = {
                ..._gateway.position,
                [name]: value,
            };
        }

        _gateway[name] = value;

        setGateway(_gateway);
    }

    function unsuccessful(msg = 'Erfolglos!') {
        return toast.error(msg);
    }

    function success() {
        return toast.success('Erfolgreich!');
    }

    function handleAssignErrors(err) {
        if (err && err.networkError) {
            const errors = err.networkError.result.errors;
            unsuccessful(errors.map((error) => error.message).join(" "));
        }
    }

    function onGarageChanged(assignedGarage) {
        setAssignedValue(assignedGarage);
    }


    function loadGarages(value) {
        setGarageDataLoading(true);
        return new Promise(resolve => {
            clearTimeout(typingTimer);
            typingTimer = setTimeout(() => {

                let garageParams = {
                    offset: 0,
                    limit: 10,
                    searchTerm: value
                };

                return garageService
                    .getService(getGaragesQuery(garageParams))
                    .then((garages) => {
                        return garages.data.getGarages.garages
                            .filter((garage) => garage.gateway_type === "SALTO")
                            .map((garage) => ({ value: garage.id, label: garage.name }))
                    })
                    .catch((err) => {
                        let errors = err.networkError.result.errors;
                        this.unsuccessful(errors.map((error) => error.message).join(" "));
                    }).then(garages => {
                        setGarageDataLoading(false);
                        resolve({ options: garages });
                    })
                    .catch((err) => {
                        let errors = err.networkError.result.errors;
                        this.unsuccessful(errors.map((error) => error.message).join(" "));
                        setGarageDataLoading(false);
                    });;

            }, typingInterval)

        })
    }

    function toggleUnassignSaltoGateway() {
        setUnassignSaltoGateway(!isUnassignSaltoGateway);
    }


    function toggleAssignSaltoGateway() {
        setAssignSaltoGateway(!isAssignSaltoGateway);
    }
    function toggleDeleteGateway() {
        setDeleteGateway(!isDeleteGateway);
    }

    function toggleDisabled() {
        setDisabled(!disabled);
    }

    function startUpdateGateway() {
        garageService.createService(updateSaltoGateway(gateway))
            .then((response) => {
                setGateway(response.data.updateSaltoGateway.gateway);
                success();
                toggleDisabled();
                document.title = "Salto Gateway | " + gateway.id || dictionary.NOT_AVAILABLE;
            })
            .catch((err) => {
                let errors = err.networkError.result.errors;
                unsuccessful(errors.map((error) => error.message).join(" "));
            });
    }

    function startAssignSaltoGateway() {
        const data = {
            id: gateway.id,
            garageId: assignedValue.value
        };

        garageService.createService(assignSaltoGateway(data))
            .then((response) => {
                fetchGateway();
                setAssignSaltoGateway(false);
                success();
            })
            .catch((err) => {
                handleAssignErrors(err);
            });
    }

    function startUnassignSaltoGateway() {
        const data = {
            id: gateway.id
        };

        garageService.createService(unassignSaltoGateway(data))
            .then((response) => {
                fetchGateway();
                setUnassignSaltoGateway(false);
                success();
            })
            .catch((err) => {
                handleAssignErrors(err);
            })
    }

    function startDeleteGateway() {
        const data = {
            id: gateway.id
        };

        garageService.createService(deleteSaltoGateway(data))
            .then((response) => {

                history.push('/salto');

                success();
            })
            .catch((err) => {
                handleAssignErrors(err);
            })
    }

    function handleRebootModule(moduleType) {
        garageService.createService(rebootNode({ id: gateway.id, component: moduleType }))
            .then(() => {
                success();
            })
            .catch((err) => {
                let errors = err.networkError.result.errors;
                unsuccessful(errors.map((error) => error.message).join(" "));
            });
    }


    function renderInitialHeader() {
        return (
            <Row className="justify-content-between">
                <Col>
                    <Widget icon="icon-organization" color="info"
                        header={gateway.name || gateway.gwid} />
                </Col>
                <Col xs="12" sm="12" md="2" lg="2">
                    <Widget
                        icon="icon-plus"
                        color="danger"
                        header="Gateway löschen"
                        invert
                        style={{ cursor: "pointer" }}
                        onClick={toggleDeleteGateway}
                    />
                </Col>
                <Col xs="12" sm="12" md="2" lg="2">
                    <Widget
                        icon="icon-plus"
                        color="success"
                        header="Knoten zuweisen"
                        invert
                        style={{ cursor: "pointer" }}
                        onClick={toggleAssignSaltoGateway}
                    />
                </Col>
            </Row>
        )
    }

    function renderAssignedHeader() {
        return (
            <Row>
                <Col xs="12" sm="12" md="10" lg="10">
                    <Widget icon="icon-organization" color="info"
                        header={gateway.name || gateway.gwid} />
                </Col>
                <Col xs="12" sm="12" md="2" lg="2">
                    <Widget
                        icon="icon-minus"
                        color="warning"
                        header="Aufheben"
                        invert
                        style={{ cursor: "pointer" }}
                        onClick={toggleUnassignSaltoGateway}
                    />
                </Col>
            </Row>
        )
    }

    function renderHeader() {
        if (gateway.garage_id) {
            return renderAssignedHeader()
        } else {
            return renderInitialHeader()
        }
    }

    function renderState(cell) {
        const color = cell ? 'text-success' : 'text-danger';
        return <div><i className={`fa fa-circle ${color} Blink`} /> {cell ? 'Online' : 'Offline'}</div>
    }

    function renderModule(moduleName, onReboot, state, moduleType) {
        return (
            <Card>
                <CardHeader>
                    <strong>{moduleName}</strong>
                </CardHeader>
                <CardBody>
                    {renderState(state)}
                    <Button type="submit" size="sm" color="success" className={"mr-1"}
                        onClick={() => onReboot(moduleType)}>
                        <i className="fa fa-refresh" />
                        Reboot
                    </Button>
                </CardBody>
            </Card>
        )
    }

    const containerStyle = {
        zIndex: 1999
    };

    if (loading) {
        return (
            <div>
                <div className="sk-rotating-plane" />
                <ToastContainer position="bottom-right" autoClose={5000} style={containerStyle} />
            </div>
        );
    }

    return (
        <div className="animated fadeIn">
            <ToastContainer position="bottom-right" autoClose={5000} style={containerStyle} />
            {renderHeader()}
            <Row>
                <Col xs="12" sm="12" md="12">
                    <Card>
                        <CardHeader>
                            Salto Gateway Infos
                            <div className="card-header-actions">
                                {
                                    !disabled
                                        ?
                                        <div>
                                            <Button type="submit" size="sm" color="success" className={"mr-1"}
                                                onClick={startUpdateGateway}>
                                                <i className="fa fa-dot-circle-o"></i> Speichern
                                            </Button>
                                            <Button type="reset" size="sm" color="danger" onClick={toggleDisabled}>
                                                <i className="fa fa-ban"></i> Abbrechen</Button></div> :
                                        <a data-testid="gateway-edit-button"
                                            className="card-header-action btn btn-setting" onClick={toggleDisabled}><i
                                                className="icon-pencil"></i></a>
                                }
                            </div>
                        </CardHeader>
                        <CardBody>
                            <Row>
                                <Col xs="12" sm="12" md="6">
                                    <FormGroup row>
                                        <Col md="3">
                                            <Label htmlFor="selectSm">Name</Label>
                                        </Col>
                                        <Col xs="12" md="9">
                                            <Input data-testid="gateway-name-input" type="text" name="name" id="name"
                                                value={!gateway.name ? "" : gateway.name}
                                                onChange={handleChange} disabled={disabled} />
                                        </Col>
                                    </FormGroup>
                                    <FormGroup row>
                                        <Col md="3">
                                            <Label htmlFor="selectSm">Device ID</Label>
                                        </Col>
                                        <Col xs="12" md="9">
                                            <Input type="text" name="device_id" id="device_id"
                                                value={gateway.device_id || ""} onChange={handleChange}
                                                disabled />
                                        </Col>
                                    </FormGroup>
                                    <FormGroup row>
                                        <Col md="3">
                                            <Label htmlFor="selectSm">Typ</Label>
                                        </Col>
                                        <Col xs="12" md="9">
                                            <Input type="select" name="type" id="type"
                                                value={!gateway.type ? dictionary.NOT_AVAILABLE : gateway.type}
                                                onChange={handleChange} disabled={disabled}>
                                                <option value="">-</option>
                                                <option value="CHECK_IN">Check In</option>
                                                <option value="CHECK_OUT">Check Out</option>
                                                <option value="CHECK_IN_OUT">Check In/Out</option>
                                                <option value="MIDGATEWAY">Zwischentür</option>
                                                <option value="MIDGATEWAY_ONLINE">Zwischentür (Online)</option>
                                                <option value="REPEATER">Signalverstärker</option>
                                                <option value="EXIT_BARRIER">Ausfahrtsschranken</option>
                                                <option value="EXIT_BARRIER_ONLINE">Ausfahrtsschranken (Online)</option>
                                            </Input>
                                        </Col>
                                    </FormGroup>
                                    <FormGroup row>
                                        <Col md="3">
                                            <Label htmlFor="selectSm">Garage ID</Label>
                                        </Col>
                                        <Col xs="12" md="9">
                                            {gateway.garage_id && <Link to={`/garages/${gateway.garage_id}`}>{`${gateway.garage_gateway.name} | ${gateway.garage_id}`}</Link>}
                                        </Col>
                                    </FormGroup>
                                    <FormGroup row>
                                        <Col md="3">
                                            <Label htmlFor="selectSm">Health</Label>
                                        </Col>
                                        <Col xs="12" md="9">
                                            {gateway.health_status && renderState(gateway.health_status.connection)}
                                        </Col>
                                    </FormGroup>
                                    <FormGroup row>
                                        <Col md="3">
                                            <Label htmlFor="latitude">Breitengrad</Label>
                                        </Col>
                                        <Col xs="12" md="9">
                                            <Input type="number" name="lat" id="lat" parent="position"
                                                value={!gateway.position ? "" : gateway.position.lat}
                                                onChange={handleChange} disabled />
                                        </Col>
                                    </FormGroup>
                                    <FormGroup row>
                                        <Col md="3">
                                            <Label htmlFor="longitude">Längengrad</Label>
                                        </Col>
                                        <Col xs="12" md="9">
                                            <Input type="number" id="long" name="long" parent="position"
                                                value={!gateway.position ? "" : gateway.position.long}
                                                onChange={handleChange} disabled />
                                        </Col>
                                    </FormGroup>
                                </Col>
                                <Col xs="12" sm="12" md="6">
                                    <FormGroup row>
                                        <Col md="3">
                                            <Label htmlFor="gwid">GWID</Label>
                                        </Col>
                                        <Col xs="12" md="9">
                                            <Input data-testid="gateway-gwid-input" type="text" name="gwid" id="gwid"
                                                value={gateway.gwid}
                                                onChange={handleChange} disabled={disabled} />
                                        </Col>
                                    </FormGroup>
                                    <FormGroup row>
                                        <Col md="3">
                                            <Label htmlFor="selectSm">Erstellt am</Label>
                                        </Col>
                                        <Col xs="12" md="9">
                                            <Input type="text" name="created_at" id="created_at"
                                                value={datetimeFormatter.forDisplay(gateway.created_at)}
                                                onChange={handleChange} disabled />
                                        </Col>
                                    </FormGroup>
                                    <FormGroup row>
                                        <Col md="3">
                                            <Label htmlFor="selectSm">Aktualisiert am</Label>
                                        </Col>
                                        <Col xs="12" md="9">
                                            <Input type="text" name="updated_at" id="updated_at"
                                                value={datetimeFormatter.forDisplay(gateway.updated_at)}
                                                onChange={handleChange} disabled />
                                        </Col>
                                    </FormGroup>
                                    <FormGroup row>
                                        <Col md="3">
                                            <Label htmlFor="selectSm">Gelöscht am</Label>
                                        </Col>
                                        <Col xs="12" md="9">
                                            <Input type="text" name="deleted_at" id="deleted_at"
                                                value={!gateway.deleted_at ? "-" : datetimeFormatter.forDisplay(gateway.deleted_at)}
                                                onChange={handleChange} disabled />
                                        </Col>
                                    </FormGroup>
                                    <FormGroup row>
                                        <Col md="3">
                                            <Label htmlFor="selectSm">Product type</Label>
                                        </Col>
                                        <Col xs="12" md="9">
                                            B2C
                                        </Col>
                                    </FormGroup>
                                </Col>
                                <Col lg="12">
                                    <hr />
                                </Col>
                            </Row>
                            <Row>
                                <Col xs="12" sm="12" md="12">
                                    <FormGroup row>
                                        <Col md="3">
                                            <Label>Notiz</Label>
                                        </Col>
                                    </FormGroup>
                                    <FormGroup row>
                                        <Col xs="12" md="12">
                                            <Input type="textarea" name="note" id="note"
                                                value={!gateway.note ? "" : gateway.note}
                                                onChange={handleChange} disabled={disabled} />
                                        </Col>
                                    </FormGroup>
                                </Col>
                            </Row>
                        </CardBody>
                    </Card>
                </Col>
            </Row>

            {/* Modals */}

            {/*Assign gateway to garage*/}
            <Modal isOpen={isAssignSaltoGateway} toggle={toggleAssignSaltoGateway}
                className={'modal-success ' + props.className}>
                <ModalHeader toggle={toggleAssignSaltoGateway}>Gateway zuweisen</ModalHeader>
                <ModalBody>
                    <AsyncSelect
                        name="assignedGarage"
                        loadOptions={loadGarages}
                        value={assignedValue}
                        onChange={onGarageChanged}
                    />
                </ModalBody>
                <ModalFooter>
                    <Button color="success" onClick={startAssignSaltoGateway}>Gateway zuweisen</Button>{' '}
                    <Button color="secondary" onClick={toggleAssignSaltoGateway}>Abbrechen</Button>
                </ModalFooter>
            </Modal>

            {/*Delete Gateway*/}
            <Modal isOpen={isDeleteGateway} toggle={toggleDeleteGateway}
                className={'modal-danger ' + props.className}>
                <ModalHeader toggle={toggleDeleteGateway}>Gateway löschen</ModalHeader>
                <ModalBody>
                    <p>Sind Sie sicher, dass Sie dieses Gateway löschen möchten?</p>
                </ModalBody>
                <ModalFooter>
                    <Button color="danger" onClick={startDeleteGateway}>Gateway löschen</Button>{' '}
                    <Button color="secondary" onClick={toggleDeleteGateway}>Abbrechen</Button>
                </ModalFooter>
            </Modal>

            {/* Unassign master */}
            <Modal isOpen={isUnassignSaltoGateway} toggle={toggleUnassignSaltoGateway}
                className={'modal-danger ' + props.className}>
                <ModalHeader toggle={toggleUnassignSaltoGateway}>Gateway wirklich deaktivieren?</ModalHeader>
                <ModalBody>
                    Wenn du dieses Gateway deaktivierst, sind Check-In und Check-Out nicht mehr möglich.<br />
                    Kund:innen können nicht mehr einfahren oder ausfahren - das führt zu Supportfällen und Umsatzverlust.<br />
                    <br />
                    Bitte nur deaktivieren, wenn es technisch zwingend notwendig ist.
                </ModalBody>
                <ModalFooter>
                    <Button color="danger" onClick={startUnassignSaltoGateway}>Deaktivierung bestätigen</Button>{' '}
                    <Button color="secondary" onClick={toggleUnassignSaltoGateway}>Abbrechen</Button>
                </ModalFooter>
            </Modal>

        </div>
    );
};

export default SaltoGateway;
